import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=6228adae&scoped=true"
import script from "./manage.vue?vue&type=script&lang=js"
export * from "./manage.vue?vue&type=script&lang=js"
import style0 from "./manage.vue?vue&type=style&index=0&id=6228adae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228adae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6228adae')) {
      api.createRecord('6228adae', component.options)
    } else {
      api.reload('6228adae', component.options)
    }
    module.hot.accept("./manage.vue?vue&type=template&id=6228adae&scoped=true", function () {
      api.rerender('6228adae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/material/consume/manage.vue"
export default component.exports